export default "__VITE_ASSET__BrdrI4Rr__"